import { Stack } from '@mui/material';
import {
    Typography,
    TypographyProps,
} from '@upheal/design-system/components/Typography/Typography';
import { PropsWithChildren } from 'react';

const Item = ({
    children,
    component = 'span',
}: PropsWithChildren<{
    component?: TypographyProps['component'];
}>) => {
    return (
        <Typography
            variant="xs"
            component={component}
            sx={{ lineHeight: '20px' }}
        >
            {children}
        </Typography>
    );
};

const ItemsList = ({ items }: { items: React.ReactNode[] }) => {
    return (
        <ul style={{ marginLeft: 16 }}>
            {items.map((item, index) => (
                <Item key={index} component="li">
                    {item}
                </Item>
            ))}
        </ul>
    );
};

type PricingCardDescriptionDetailsProps = {
    paragraph: React.ReactNode;
    items: React.ReactNode[];
};

export const PricingCardDescriptionDetails = (
    props: PricingCardDescriptionDetailsProps,
) => {
    const { paragraph, items } = props;
    return (
        <Stack>
            <Item>{paragraph}</Item>
            <ItemsList items={items} />
        </Stack>
    );
};
